import { ICommand } from 'core-ts-types';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { FeedbackSuggestedPlanModel } from '../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { AdvisorHeaderDetailsQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_plan_details_query';

class PlanLooksGood {
  private disablePlanLooksGood: boolean = false;

  constructor(
    private ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery,
    private createEmptySuggestedPlanCommand: ICommand,
    private $state: ng.ui.IStateService,
    private ngAPNotificationDelegate: INotificationDelegate,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
    private deleteSuggestedPlanCommand: ICommand,
    private commitSuggestedPlanCommand: ICommand
  ) {}

  createPlan() {
    const showSuccessNotification = false;
    return this.createEmptySuggestedPlanCommand(showSuccessNotification);
  }

  addCommentAndSendPlan() {
    const suggestedPlan = this.ngFeedbackSuggestedPlanModel.read();
    const comment = 'Plan looks good!';
    return this.commitSuggestedPlanCommand(comment, suggestedPlan.id);
  }

  sendPlanLooksGood() {
    this.disablePlanLooksGood = true;

    const sendPlanAlertName = 'send-plan-alert-name';
    this.ngAPNotificationDelegate.info({ content: 'Sending plan...', name: sendPlanAlertName });

    this.createPlan()
      .then(() => this.addCommentAndSendPlan())
      .then(() => {
        this.$state.go(`ap-advisor.student-plan-progress`, {}, { reload: true });
        this.ngAPNotificationDelegate.dismissAlertByName(sendPlanAlertName);
        return this.ngAPNotificationDelegate.success(`Successfully sent plan!`);
      })
      .catch(() => {
        this.ngAPNotificationDelegate.dismissAlertByName(sendPlanAlertName);
        const suggestedPlan = this.ngFeedbackSuggestedPlanModel.read();
        if (suggestedPlan.id) {
          // regardless whatever happened, we want to show error message at the end
          return this.deleteSuggestedPlanCommand().finally(() =>
            this.ngAPNotificationDelegate.error(`Unable to send the plan`)
          );
        } else {
          return this.ngAPNotificationDelegate.error(`Unable to send the plan`);
        }
      })
      .finally(() => (this.disablePlanLooksGood = false));
  }
}

angular.module('capability-ng-academic-planner').component('planLooksGood', {
  templateUrl: 'capability-ng-academic-planner/src/advisor_header/components/plan_looks_good/plan_looks_good.html',
  controller: PlanLooksGood
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/plan_looks_good/plan_looks_good.ts